import { Component, Inject, OnInit, ViewEncapsulation } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { FormControl, FormGroup } from "@angular/forms";
import { RecordAction } from "../../../../../../../../../utils/enums/shared/enums";
import { AppService } from "../../../../../../../../../services/admon/app.service";
import { App } from "../../../../../../../../../utils/types/admon/app.type";
import { CustomValidators } from "@rizwan3d/ngx-custom-validators-16";

@Component({
    selector: "wtf-app-form",
    templateUrl: "./app-form.component.html",
    styleUrls: ["./app-form.component.scss"],
    encapsulation: ViewEncapsulation.None,
    providers: [AppService],
})
export class AppFormComponent implements OnInit {
    app: App = new App();
    dialogTitle: string;
    appForm: FormGroup;
    action: RecordAction;
    callback: (app) => void;

    recordAction = RecordAction;
    form: FormGroup;

    constructor(
        public dialogRef: MatDialogRef<AppFormComponent>,
        @Inject(MAT_DIALOG_DATA) private data: any
    ) {
        this.action = data.action;
        this.callback = data.callback;

        if (
            this.action === RecordAction.Update ||
            this.action === RecordAction.View
        ) {
            this.app = data.app;
            this.dialogTitle = this.app.name;
        } else {
            this.dialogTitle = "Nueva Aplicación";
        }

        this.appForm = this.createForm();
    }

    ngOnInit() {}

    createForm() {
        this.form = new FormGroup({
            name: new FormControl(this.app.name),
            redirectUri: new FormControl(
                this.app.redirectUri,
                CustomValidators.url
            ),
        });

        const form = this.form;

        form.controls["name"].valueChanges.subscribe(
            (value) => (this.app.name = value)
        );
        form.controls["redirectUri"].valueChanges.subscribe(
            (value) => (this.app.redirectUri = value)
        );
        return form;
    }

    saveApp() {
        if (this.appForm.invalid) {
            return;
        }

        this.callback(this.app);
    }
}
